import { getContext, invoke, getFrameId, reload } from './core';
import { initFeatureFlags, trackFeatureFlagEvent } from './featureFlags';
import { emitFrontendCustomMetric } from './frontendCustomMetrics';
import { iframeAnalytics, trackObjectStoreAction, ufoEvent } from './telemetry';
import { bridgeConfigDelegates } from './bridge-config-delegates';
import { fetchProduct } from './fetchProduct';
import { fetchRemote } from './fetchRemote';
import { requestTeamworkGraph } from './requestTeamworkGraph';
import { enableTheming } from './enableTheming';
import { on, emit } from './events';
import { onPublic, emitPublic } from './publicEvents';
import { subscribeRealtimeChannel, publishRealtimeChannel } from './realtime';
import { getUrl, navigate } from './navigation';
import { createHistory } from './history';
import { openRovo, isRovoEnabled } from './rovo';
import { permissionBridgeMethods } from './permissions';
import type { TAnyBridgeMethod } from './types';

export const bridgeMethods: Record<string, TAnyBridgeMethod> = {
	...bridgeConfigDelegates,
	// Core methods
	getContext,
	invoke,
	getFrameId,
	reload,
	// Fetch methods
	fetchProduct,
	fetchRemote,
	requestTeamworkGraph,
	// Theming methods
	enableTheming,
	// Event methods
	on,
	emit,
	// Public event methods
	onPublic,
	emitPublic,
	// Realtime methods
	subscribeRealtimeChannel,
	publishRealtimeChannel,
	// Navigation methods
	getUrl,
	navigate,
	// History methods
	createHistory,
	// Feature flag methods
	initFeatureFlags,
	trackFeatureFlagEvent,
	// Frontend custom metrics
	emitFrontendCustomMetric,
	// Telemetry methods
	'iframe-analytics': iframeAnalytics,
	trackObjectStoreAction,
	'ufo-event': ufoEvent,
	// Rovo methods
	isRovoEnabled,
	openRovo,
	// Permission methods
	...permissionBridgeMethods,
};
